import { Route, Routes } from "react-router-dom";
import CouncilModule from ".";

const CouncilRoute = () => {
  return (
    <Routes>
      <Route path="/:view" element={<CouncilModule />} />
      <Route path="/*" element={<CouncilModule />} />
    </Routes>
  );
};

export default CouncilRoute;
